module.exports = __webpack_public_path__ + "img/40_36.d6c92c86.png";